import {
  SET_PENDING_ACTION,
  SET_MODIFIED_TIME,
  SET_EXECUTE_PENDING_ACTION,
  SET_PROCEDURE_ID,
} from "../actions/constants";

const initialState = {
  pendingAction: null,
  modifiedTime: null,
  isExecutePendingAction: false,
  procedureId: null,
};

const procedureDetailPageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PENDING_ACTION:
      return {
        ...state,
        pendingAction: action.payload,
      };
    case SET_MODIFIED_TIME:
      return {
        ...state,
        modifiedTime: action.payload,
      };
    case SET_EXECUTE_PENDING_ACTION:
      return {
        ...state,
        isExecutePendingAction: action.payload,
      };
    case SET_PROCEDURE_ID:
      return {
        ...state,
        procedureId: action.payload,
      };
    default:
      return state;
  }
};

export default procedureDetailPageReducer;
